<template>
    <e-panel class="advanced-properties-component" :x.sync="position.x" :y.sync="position.y" :min-width="900"
             body-class="p-0" header-class="py-1 pr-1" footer-class="p-2"
             @close="visibleComputed = false">
        <template #header>
            <div class="text-center w-100">
                {{`Advanced properties|Propriétés avancées`|tr}}
                <span v-if="isLocal()" class="f-400 f-10 ml-2">#{{component.id}}</span>
            </div>
        </template>

        <b-tabs vertical>
            <slot></slot>
<!--            <b-tab title="Style" :active="tab === `style`">-->
<!--                <sidebar-group :title="tr(`Custom CSS|CSS personnalisé`)" no-left-padding>-->
<!--                    <b-form-group>-->
<!--                        <monaco-editor v-model="component.css" lang="css" :block="block" :component="component"/>-->
<!--                    </b-form-group>-->
<!--                    <slot name="style"></slot>-->
<!--                </sidebar-group>-->
<!--            </b-tab>-->
            <b-tab title="Code" :active="tab === `code`">
                <sidebar-group :title="tr(`Liquid Code|Code Liquid`)" no-left-padding>
                    <template #actions>
                        <b-checkbox :checked="component.plugins.liquid?.active === true" @change="toggleLiquidPlugin" class="toggle-active float-right" size="lg"/>

                        <b-dropdown v-if="component.plugins.liquid?.active === true" class="mr-1 float-right" right size="xs" variant="outline-white" no-caret>
                            <template #button-content>
                                <i class="fas fa-ellipsis-h"/>
                            </template>
                            <b-dropdown-item link-class="text-danger" @click="component.plugins.liquid = null">
                                <i class="fas fa-trash"/>
                                <span v-tr>Delete Plugin|Supprimer le plugin</span>
                            </b-dropdown-item>
                        </b-dropdown>
                    </template>
                    <template v-if="component.plugins.liquid?.active === true">
                        <b-form-group>
                            <monaco-editor v-model="component.plugins.liquid.code" lang="liquid" :item="boundItem" :block="block" :component="component"/>
                        </b-form-group>
                        <slot name="liquid"></slot>
                    </template>
                </sidebar-group>
            </b-tab>
        </b-tabs>

<!--        <sidebar-group v-if="component.active && component.mediaQuery.expanded" :title="'Device Display|Affichage par appareil'|tr" sub-group>-->
<!--            <b-form-group>-->
<!--                <btn-checkbox v-model="component.mediaQuery.desktop.visible" :title="'Select if visible on desktop device|Visibilité sur ordinateur'|tr">-->
<!--                    <i class="fas fa-desktop" style="font-size: 16pt;"/>-->
<!--                </btn-checkbox>-->
<!--                <btn-checkbox v-model="component.mediaQuery.tablet.visible" :title="'Select if visible on tablet device|Visibilité sur tablette'|tr">-->
<!--                    <i class="fas fa-tablet-screen" style="font-size: 16pt;"/>-->
<!--                </btn-checkbox>-->
<!--                <btn-checkbox v-model="component.mediaQuery.mobile.visible" :title="'Select if visible on mobile device|Visibilité sur mobile'|tr">-->
<!--                    <i class="fas fa-mobile-iphone" style="font-size: 16pt;"/>-->
<!--                </btn-checkbox>-->
<!--                <btn-checkbox v-model="component.mediaQuery.kiosk.visible" :title="'Select if visible on kiosk device|Visibilité sur kiosque'|tr">-->
<!--                    <i class="fak fa-kiosk" style="font-size: 16pt;"/>-->
<!--                </btn-checkbox>-->
<!--                <btn-checkbox v-model="component.mediaQuery.wheelchair.visible" :title="'Select if visible on kiosk with wheelchair mode|Visibilité sur kiosque en mode handicapé'|tr">-->
<!--                    <i class="fas fa-wheelchair" style="font-size: 16pt;"/>-->
<!--                </btn-checkbox>-->
<!--            </b-form-group>-->
<!--        </sidebar-group>-->
        <template #footer>
            <b-btn @click="visibleComputed = false" variant="white" class="py-1">
                <span v-tr>Close|Fermer</span>
            </b-btn>
        </template>
    </e-panel>
</template>

<script>
import SidebarGroup from "@components/editor/properties/components/sidebar-group.vue";
import BtnCheckbox from "@components/editor/properties/inputs/btn-checkbox.vue";
import EBtnCheckbox from "../../../../../vue-components/components/e-btn-checkbox.vue";
import EPanel from "../../../../../vue-components/components/e-panel.vue";
import CmsPluginLiquidComponent from "@/helpers/editor/plugins/CmsPluginLiquidComponent.js";
import MonacoEditor from "@components/editor/monaco-editor.vue";

export default {
    name: `advanced-properties-component`,
    components: {MonacoEditor, EPanel, BtnCheckbox, EBtnCheckbox, SidebarGroup},
    props: {
        value: {type: Object, required: true},
        block: {type: Object},
        boundItem: {type: Object},
        visible: {type: Boolean},
        tab: {type: String}
    },
    computed: {
        component: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit(`input`, value);
            }
        },
        visibleComputed: {
            get() {
                return this.visible;
            },
            set(value) {
                this.$emit(`update:visible`, value);
            }
        },
        previewIcon() {
            switch (this.previewMode) {
                case `mobile`:
                    return `fas fa-mobile-iphone`;
                case `tablet`:
                    return `fas fa-tablet-screen`;
                case `kiosk`:
                    return `fak fa-kiosk`;
                default:
                    return `fas fa-desktop`;
            }
        },
        bindingEnabled() {
            return this.cmsPage.itemType || (this.block.cmsEnabled && this.block.itemId);
        },
        itemTypeDef() {
            if (!this.block.pageItemTypeDef) {
                return null;
            }
            return this.block.pageItemTypeDef;
        }
    },
    data() {
        return {
            // temp until I fix e-panel with dialog
            position: {x: -1000, y: 200}
        }
    },
    methods: {
        toggleLiquidPlugin() {
            if (!this.component.plugins.liquid) {
                this.$set(this.component.plugins, `liquid`, new CmsPluginLiquidComponent());
            } else {
                this.component.plugins.liquid.active = !this.component.plugins.liquid.active;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .toggle-active {
    display: inline-flex;
    top: -3px;
    //position: absolute;
    //left: 5px;
    //top: 4px;
}

.toggle-binding {
    position: relative;
    top: 0;
    //border-radius: 3px;
    padding: 3px 2px;
    line-height: 1;

    &.btn-outline {
        color: #555;
        background: rgba(white, 1);
    }
}

.advanced-properties-component {
    .tabs.row {
        margin: 0;
        width: 100%;

        // Nav Side Menu
        > :deep(.col-auto) {
            padding: 0 !important;
            background-color: #f5f5f5 !important;
            border-right: 1px solid var(--border-color);
            border-bottom: 1px solid var(--border-color);

            > .nav-tabs {
                background: transparent;
            }
        }

        // content
        > :deep(.col) {
            padding: 0 !important;

            .tab-pane {
                //padding: 0.5rem 1rem;
                background-color: #f0f5f9;

                .sidebar-group.small-group {
                    .sidebar-group-body {
                        width: 360px;
                        max-width: 100%;
                    }
                }
            }
        }
    }

    :deep(.panel-header) {
        border-bottom: 1px solid var(--border-color);
    }

    :deep(.panel-footer) {
        background: #f0f5f9;
    }
}
</style>
